import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  BatchParametrizationForceRunResponseSchema,
  BatchParametrizationStopResponseSchema,
} from './batch-parametrization-controls.schema';

const operatorControlMeta = {
  permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
};

export const batchParametrizationControlsContractRoutes = {
  runBatchParametrization: terraContract
    .meta(operatorControlMeta)
    .route({
      method: 'POST',
      path: '/{id}/batch-parametrization/run',
      summary: 'Force a batch URL parametrization run',
      description:
        'Starts a batch URL parametrization run now and skips the crawl gate. Returns already_running when a run is active, or blocked when poison generation has not been passed. Requires Terra tenant access.',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(BatchParametrizationForceRunResponseSchema),
  stopBatchParametrization: terraContract
    .meta(operatorControlMeta)
    .route({
      method: 'POST',
      path: '/{id}/batch-parametrization/stop',
      summary: 'Stop the active batch URL parametrization run',
      description:
        'Ends the active run if any, then deletes trigger, retry, poison, pending, and active-run keys. Requires Terra tenant access.',
      inputStructure: 'detailed',
    })
    .input(z.object({ params: ApplicationsIdSchema }))
    .output(BatchParametrizationStopResponseSchema),
};
